import {
  deleteDocumentResponseSchema,
  documentInvalidFileResponseSchema,
  documentStatusResponseSchema,
  notFoundResponseSchema,
} from 'xosign-types';

import { z } from 'zod';
import { API_URL_BASE } from '@/config';
import { type EndpointDefinition } from '@/types/endpointTypes';

// Extend request objects only for frontend with necessary path params
const CRUD = {
  r: z.object({
    parentId: z.string(),
    parentPath: z.string(),
    documentId: z.string(),
  }),
  d: z.object({
    parentId: z.string(),
    parentPath: z.string(),
    documentId: z.string(),
  }),
};

const endpoints = {
  'documents.delete': {
    method: 'DELETE',
    url: `${API_URL_BASE}:parentPath/:parentId/documents/:documentId`,
    requestSchema: CRUD.d,
    responseSuccessSchema: deleteDocumentResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      400: documentInvalidFileResponseSchema,
      404: notFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof CRUD.d,
    typeof deleteDocumentResponseSchema,
    {
      400: typeof documentInvalidFileResponseSchema;
      404: typeof notFoundResponseSchema;
    }
  >,
  'documents.status': {
    method: 'GET',
    url: `${API_URL_BASE}:parentPath/:parentId/documents/:documentId/status`,
    requestSchema: CRUD.r,
    responseSuccessSchema: documentStatusResponseSchema,
    requiresToken: 'local',
    responseErrorSchemas: {
      404: notFoundResponseSchema,
    },
  } satisfies EndpointDefinition<
    typeof CRUD.d,
    typeof documentStatusResponseSchema,
    {
      404: typeof notFoundResponseSchema;
    }
  >,
};

export default endpoints;
